import { getIntlLocale } from './format';

/**
 * Spec 525: locale-aware relative time via the native Intl.RelativeTimeFormat
 * (no dependency; German/English come from the active i18n locale). Returns the
 * largest sensible unit, e.g. "vor 3 Stunden" / "3 hours ago". `null`/invalid
 * input → `null` (the caller renders a "never" label).
 */

const DIVISIONS: { amount: number; unit: Intl.RelativeTimeFormatUnit }[] = [
  { amount: 60, unit: 'second' },
  { amount: 60, unit: 'minute' },
  { amount: 24, unit: 'hour' },
  { amount: 7, unit: 'day' },
  { amount: 4.34524, unit: 'week' },
  { amount: 12, unit: 'month' },
  { amount: Number.POSITIVE_INFINITY, unit: 'year' },
];

export function formatRelativeTime(
  iso: string | null | undefined,
  nowMs: number = Date.now(),
): string | null {
  if (!iso) return null;
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return null;

  const rtf = new Intl.RelativeTimeFormat(getIntlLocale(), { numeric: 'auto' });
  let duration = (then - nowMs) / 1000; // seconds; negative = in the past

  for (const division of DIVISIONS) {
    if (Math.abs(duration) < division.amount) {
      return rtf.format(Math.round(duration), division.unit);
    }
    duration /= division.amount;
  }
  return rtf.format(Math.round(duration), 'year');
}
